import { useContext } from 'react';

import { CoreContext } from '../context/CoreContext';

const useReadResponseDataModifier = endpoint => {
  const { coreData } = useContext(CoreContext);
  const { corporate: isCorporateMode } = coreData.booking_engine;
  if (endpoint == null) return null;

  if (isCorporateMode) {
    if (endpointNeedsCorporateGetModifier(endpoint)) return CorporateModeResponseGetModifier;
    if (endpointNeedsCorporatePostModifier(endpoint)) return CorporateModeResponsePostModifier;
  }
  return null;
};

export default useReadResponseDataModifier;

class BaseResponseModifier {
  process(target, updater) {
    if (Array.isArray(target)) {
      return target.map(updater);
    }
    return updater(target);
  }
}

const endpointNeedsCorporateGetModifier = endpoint => {
  if (endpoint.includes('available-days')) return false;
  if (endpoint.includes('/products/')) return true;
  return false;
};

const endpointNeedsCorporatePostModifier = endpoint => {
  if (endpoint.includes('/session-group/details')) return true;
  return false;
};

class CorporateModeResponseGetModifier extends BaseResponseModifier {
  updateValues(data) {
    const updater = obj => {
      // product
      if ('free' in obj) obj.free = true;
      if ('prices' in obj) obj.prices = [];
      if ('price_from' in obj) obj.price_from = '0.00';
      if ('sell_gift_voucher_online' in obj) obj.sell_gift_voucher_online = 0;
      // ava
      if ('price' in obj) obj.price = '0.00';
      if ('price_without_promo' in obj) obj.price_without_promo = '0.00';
      return obj;
    };

    if (data && typeof data === 'object') {
      if ('product' in data) {
        data.product = this.process(data.product, updater);
      } else {
        data = this.process(data, updater);
      }
    }

    return data;
  }
}

class CorporateModeResponsePostModifier extends BaseResponseModifier {
  updateValues(data) {
    const updater = obj => {
      // P3
      if ('prices' in obj) obj.prices = [];
      if ('standard_price' in obj) obj.standard_price = '0.00';
      if ('options' in obj) {
        for (const opt of obj.options) {
          for (const ress of opt.resources) {
            ress.price = '0.00';
          }
        }
      }
      return obj;
    };

    if (data && typeof data === 'object') {
      if ('product' in data) {
        data.product = this.process(data.product, updater);
      } else {
        data = this.process(data, updater);
      }
    }

    return data;
  }
}
